import { Banner, Typography } from '../../components/primitives';
import { useBlurbContext } from '../../context/Blurb.context';
import { useCartHook } from '../../hooks/cartHook';
import { CartWithItems } from './CartWithItems';
import { CartWithoutItems } from './CartWithoutItems';
import { useTranslation } from '@rpi/i18n';
import React from 'react';

export const CartRoute = () => {
  const { cart, bannerText } = useCartHook();
  const { settings } = useBlurbContext();
  const { t } = useTranslation(undefined, { keyPrefix: 'route.cart' });

  return (
    <div>
      {bannerText && (
        <Banner data-testid="cart">
          <Typography variant="banner">{bannerText}</Typography>
        </Banner>
      )}
      <div className="flex flex-grow flex-col mx-8 md:mx-20 space-y-10 m-10">
        <div className="flex justify-between">
          <Typography as="h1" variant="title-default" className="">
            {t('cart_title')}
          </Typography>
          <Typography as="span" variant="body" className="">
            {t('currency')}
            {': '}
            <span data-testid="cart-currency">
              {settings?.preferredCurrency}
            </span>
          </Typography>
        </div>
        {(cart?.lineItems?.length ?? 0) > 0 ? (
          <CartWithItems />
        ) : (
          <CartWithoutItems />
        )}
      </div>
    </div>
  );
};
